import { render, staticRenderFns } from "./AssetsFS.vue?vue&type=template&id=0c10e46e"
import script from "./AssetsFS.vue?vue&type=script&lang=ts"
export * from "./AssetsFS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports